/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardTransactionEvidenceRecords200ResponseInnerWarnings
 */
export interface GetCardTransactionEvidenceRecords200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'detectedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'colorGradation'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'heightMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionEvidenceRecords200ResponseInnerWarnings
     */
    'widthMillis'?: GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum;
}

export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsColorGradationEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsHeightMillisEnum];
export const GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetCardTransactionEvidenceRecords200ResponseInnerWarningsWidthMillisEnum];


